module.exports = __webpack_public_path__ + "static/media/acaramite_50ws.b1fa0987.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/climasense/aranha_roja_fresa/curativa/acaramite_50ws.png
// module id = 1534
// module chunks = 3